import QuestionAnswersPrefillGreen1 from './question-answers-green-1.json';
import QuestionAnswersPrefillGreen2 from './question-answers-green-2.json';
import QuestionAnswersPrefillGreen3 from './question-answers-green-3.json';

export default [
  QuestionAnswersPrefillGreen1,
  QuestionAnswersPrefillGreen2,
  QuestionAnswersPrefillGreen3,
];
